const footerLinks = [
  { title: '推荐内容', href: '#cards' },
  { title: '精选专题', href: '#carousel' },
  { title: '手机看视频', href: '#app' },
  { title: '平台特色', href: '#features' },
  { title: '内容索引', href: '#index' },
  { title: '联系我们', href: '#contact' },
];

const resourceLinks = [
  { title: '91免费在线视频', href: '#index' },
  { title: '91麻豆免费视频', href: '#index' },
  { title: '91福利视频在线', href: '#index' },
  { title: '免费高清视频', href: '#index' },
  { title: '精彩视频推荐', href: '#index' },
];

export default function Footer() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer id="footer" className="w-full bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 lg:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-circle-fill text-background-50 text-lg" />
              </div>
              <span className="font-heading font-bold text-lg text-foreground-950">
                91免费视频网站
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-md mb-4">
              91免费视频网站致力于打造最全面的免费在线视频聚合平台，覆盖91免费在线视频、91麻豆免费视频网站、91福利视频在线等海量资源。每日稳定更新，零成本享受高清不卡顿的观影体验。
            </p>
            <p className="text-xs text-foreground-500 leading-relaxed">
              本站所有内容仅供学习交流用途，请用户遵守当地法律法规，合理使用平台资源。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-4">快速导航</h4>
            <ul className="space-y-3">
              {footerLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => handleClick(e, link.href)}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {link.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-4">热门资源</h4>
            <ul className="space-y-3">
              {resourceLinks.map((link) => (
                <li key={link.title}>
                  <a
                    href={link.href}
                    onClick={(e) => handleClick(e, link.href)}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {link.title}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-800 mb-4">合作伙伴</h4>
            <p className="text-xs text-foreground-500 leading-relaxed mb-3">
              我们正在与各大内容平台建立合作关系，共同为用户提供更丰富优质的免费在线视频资源。
            </p>
            <div className="flex items-center gap-2 text-xs text-foreground-400">
              <div className="w-8 h-8 rounded-lg bg-background-200/70 flex items-center justify-center">
                <i className="ri-building-line" />
              </div>
              <span>合作伙伴招募中</span>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200/50">
        <div className="w-full px-4 md:px-6 lg:px-10 py-5">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-500">
              91免费视频网站 版权所有
            </p>
            <p className="text-xs text-foreground-500">
              91免费在线视频 · 91麻豆免费视频网站 · 91福利视频在线
            </p>
            <p className="text-xs text-foreground-400 hidden lg:block">
              每日更新 · 高清画质 · 免费观看
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}